export const environment = {
  production: true,
  apiBaseUrl: 'https://ppta-propraize-api-1e38c941c231.herokuapp.com/api',
  arcgisAssetsBaseUrl: 'https://js.arcgis.com/4.31/@arcgis/core/assets',
  entraClientId: '426d8752-edf8-4021-a6b6-41d9c8c60869',
  entraTenantId: '871611e4-7b8a-4485-88e5-9570510c88a2',
  entraRedirectUri: 'https://propraize.pptaxappeal.com/auth',
  entraApiScope: 'api://7839221e-c0f7-48cd-926d-87ed64887f9d/access_as_user',
  defaultLogLevels: {
    auth: 'warn',
  },
  warnings: [
    'Configure a Google Maps API key before enabling map imagery features.',
    'Set the API base URL in the environment files when targeting another backend.',
  ],
} as const;
